import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldCheck, ArrowLeft } from "lucide-react";

export default function Login() {
  const [params] = useSearchParams();
  const err = params.get("err");

  const onGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <main
      className="min-h-screen grid place-items-center bg-[rgb(var(--page))] px-5"
      data-testid="login-page"
    >
      <div className="w-full max-w-md rounded-3xl bg-white hairline shadow-soft p-8">
        <Link
          to="/"
          className="inline-flex items-center gap-1 text-xs font-bold text-muted-ink hover:text-ink"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> Back to site
        </Link>
        <div className="mt-4 h-11 w-11 rounded-xl bg-orange-50 grid place-items-center">
          <ShieldCheck className="h-5 w-5 text-orange-600" />
        </div>
        <h1 className="mt-4 font-display font-black text-2xl text-ink">
          Admin access
        </h1>
        <p className="mt-2 text-sm text-ink-2">
          Sign in with Google to view and export leads for Bangalore Paint Pros.
        </p>

        {err ? (
          <div className="mt-4 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">
            Sign-in failed. Please try again.
          </div>
        ) : null}

        <Button
          onClick={onGoogle}
          data-testid="login-google-btn"
          className="mt-6 w-full h-12 rounded-full bg-ink hover:bg-slate-800 text-white font-bold"
        >
          <svg
            className="h-4 w-4 mr-2"
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#FFC107"
              d="M43.6 20.5H42V20H24v8h11.3C33.7 32.3 29.3 35.5 24 35.5c-6.3 0-11.5-5.2-11.5-11.5S17.7 12.5 24 12.5c2.9 0 5.6 1.1 7.6 2.9l5.7-5.7C33.9 6.5 29.2 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.3-.3-3.5z"
            />
            <path
              fill="#FF3D00"
              d="M6.3 14.1l6.6 4.8C14.7 15.1 19 12.5 24 12.5c2.9 0 5.6 1.1 7.6 2.9l5.7-5.7C33.9 6.5 29.2 4.5 24 4.5 16.3 4.5 9.7 8.9 6.3 14.1z"
            />
            <path
              fill="#4CAF50"
              d="M24 43.5c5.1 0 9.8-2 13.3-5.2l-6.1-5.2C29.2 34.8 26.7 35.5 24 35.5c-5.3 0-9.7-3.2-11.3-7.7L6 32.6C9.4 38.6 16.1 43.5 24 43.5z"
            />
            <path
              fill="#1976D2"
              d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.6l6.1 5.2c-.4.4 6.8-5 6.8-14.8 0-1.2-.1-2.3-.4-3.5z"
            />
          </svg>
          Continue with Google
        </Button>
        <p className="mt-4 text-[11px] text-muted-ink text-center">
          You&apos;ll be redirected securely to Google and back.
        </p>
      </div>
    </main>
  );
}
